import React from 'react';
import ThemedButton from '../CommonComponents/ThemedButtons';

type Props = {
  queueName: string;
  onDone: Function;
};
export function DuplicateQueueName(props: Props) {
  return (
    <div className='duplicate-queuename-w'>
      <div>
        Another queue with the name <strong>{props.queueName}</strong> already exists for
        this bot. Please use another name.
      </div>
      <div>
        <ThemedButton title='Got it' theme='3' onClick={props.onDone} />
      </div>
    </div>
  );
}
